import { RESULTS_PER_PAGE } from "../../../utils/constants";

export const paramMap = {
  briefOwner: "brief_owner",
  dateFrom: "start_at_after",
  dateTo: "end_at_before",
  regions: "regions",
  status: "status",
  template: "template",
};

export const defaultParams = {
  limit: [RESULTS_PER_PAGE],
  page: [1],
};
